import { useQuery } from "@tanstack/react-query";
import { getDoctor } from "../../../services/doctors";

import { useToast } from "../../../components/ui/use-toast";
import { useEffect } from "react";

export function useDoctor(professionalId: string | undefined, enabled = true) {
  const { toast } = useToast();

  const {
    data: doctor,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["doctor-details", professionalId],
    queryFn: () => getDoctor(professionalId),
    enabled: enabled && !!professionalId,
  });

  useEffect(() => {
    if (isError) {
      toast({
        title: "Failed to fetch doctor profile",
        variant: "destructive",
      });
    }
  }, [isError, toast]);

  return { doctor, isLoading };
}
